import { render, staticRenderFns } from "./AuctionsList.vue?vue&type=template&id=5140aeb4&scoped=true"
import script from "./AuctionsList.vue?vue&type=script&lang=js"
export * from "./AuctionsList.vue?vue&type=script&lang=js"
import style0 from "./AuctionsList.vue?vue&type=style&index=0&id=5140aeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140aeb4",
  null
  
)

export default component.exports